export default from './promote-moderator-modal';



// WEBPACK FOOTER //
// ./app/components/promote-moderator-modal/index.js